import { render, staticRenderFns } from "./NomePessoaInput.vue?vue&type=template&id=5953673c&"
import script from "./NomePessoaInput.vue?vue&type=script&lang=js&"
export * from "./NomePessoaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports